import { apiSlice } from "../app/api/apiSlice";

export const tableStyleApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUserStyleOrDefault: builder.query({
            query: (table) => `TableStyle/GetUserStyleOrDefault?table=${table}`,
            keepUnusedDataFor: 10,
            providesTags: (result, error, arg) => [
                {type: 'TableStyle', id: arg}
            ]
        }),
        updateColumnsForUser: builder.mutation({
            query: ({table, columns}) => ({
                url: `TableStyle/UpdateColumnsForUser?table=${table}`,
                method: 'POST',
                body: columns
            })
        })
    })
})

export const { useGetUserStyleOrDefaultQuery, useUpdateColumnsForUserMutation} = tableStyleApi